import {
  CardTypeResponse,
  CreateCardTypeRequest,
} from '../../model/Card-type.model';
import axiosInstance from '../../utils/axiosInstance';
import axios from 'axios';

class CardTypeService {
  private readonly baseUrl = '/card-types';

  async getCardTypeList(): Promise<CardTypeResponse[]> {
    try {
      const { data } = await axiosInstance.get(this.baseUrl);
      return data;
    } catch (error) {
      console.error('Lỗi khi tải danh sách loại thẻ:', error);
      throw new Error(
        'Lỗi khi tải danh sách loại thẻ: ' + this.getErrorMessage(error)
      );
    }
  }

  async createCardType(
    cardType: CreateCardTypeRequest
  ): Promise<CardTypeResponse> {
    try {
      const { data } = await axiosInstance.post(
        `${this.baseUrl}/create`,
        cardType
      );
      return data;
    } catch (error) {
      console.error('Lỗi khi tạo loại thẻ:', error);
      throw new Error('Lỗi khi tạo loại thẻ: ' + this.getErrorMessage(error));
    }
  }

  async getCardTypesByBankId(bankId: number): Promise<CardTypeResponse[]> {
    try {
      const { data } = await axiosInstance.get(
        `${this.baseUrl}/bank/${bankId}`
      );
      return data.length ? data : [];
    } catch (error) {
      console.error('Lỗi khi tải loại thẻ theo ngân hàng:', error);
      throw new Error(
        'Lỗi khi tải loại thẻ theo ngân hàng: ' + this.getErrorMessage(error)
      );
    }
  }

  async updateCardType(
    id: number,
    cardTypeRequestDto: CreateCardTypeRequest
  ): Promise<CardTypeResponse> {
    try {
      const { data } = await axiosInstance.put(
        `${this.baseUrl}/edit/${id}`,
        cardTypeRequestDto
      );
      return data;
    } catch (error) {
      console.error('Lỗi khi cập nhật loại thẻ:', error);
      throw new Error(
        'Lỗi khi cập nhật loại thẻ: ' + this.getErrorMessage(error)
      );
    }
  }

  async deleteCardType(id: number): Promise<void> {
    try {
      await axiosInstance.delete(`${this.baseUrl}/delete/${id}`);
    } catch (error) {
      console.error('Lỗi khi xóa loại thẻ:', error);
      throw new Error('Lỗi khi xóa loại thẻ: ' + this.getErrorMessage(error));
    }
  }

  // Helper method to extract error messages
  private getErrorMessage(error: any): string {
    return (
      error.response?.data?.message || error.message || 'Lỗi không xác định'
    );
  }
}

export default new CardTypeService();
